<div class="product-overview-root">
  <div class="product-card">
    <img
      *ngIf="data.image"
      [src]="data.image"
      alt="productImg"
      (error)="handleImageError()"
    />

    <div *ngIf="!data.image" class="default-img">
      <nb-icon icon="printer-outline"></nb-icon>
    </div>

    <div class="product-card-info">
      <h3>{{ data.name }}</h3>
      <p>{{ participatingProductLabel | transloco }}</p>
    </div>
  </div>
  <div class="product-details">
    <p>
      <strong>{{ printerHeadersLabel | transloco }} </strong
      >{{ data.headers.join('; ') }}
    </p>
    <p>
      <strong>{{ printerFamilyLabel | transloco }}: </strong>Series
      {{ data.family }}
    </p>
  </div>
  <button class="edit" mat-icon-button (click)="goToProductEdit()">
    <nb-icon icon="edit-outline"></nb-icon>
  </button>
</div>
